import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { DataService } from "src/app/services/data.service";
import { environment } from "src/environments/environment";
import { AppInsightsService } from "src/app/services/app-insights.service";
import {
  IAlbum,
  IEvent,
  Lightbox,
  LIGHTBOX_EVENT,
  LightboxEvent,
} from "ngx-lightbox";
import { Observable, of, Subscription } from "rxjs";
import {
  AlertDialogComponent,
  ConfirmDialogModel,
} from "src/app/shared/alert-dialog/alert-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, ResolveEnd } from "@angular/router";
import { UserProfileService } from "../../core/http/user-profile.service";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { NavigationExtras, Router } from "@angular/router";
import { PrintPDFService } from "../../services/printPDF.service";
import { Wirecount } from "src/app/models/wirecount.model";
import { FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { AdUserProfile } from "src/app/models/ad-user-profile";
import { untilDestroyed } from "src/app/core/until-destroyed";
import { tap } from "rxjs/operators";
import {
  ApproverLevel
} from "../../models/wire-count-labels";
import { AlertService, AlertType } from "src/app/services/alert.service";
import * as CryptoJS from 'crypto-js';

@Component({
    selector: "app-view-testslips",
    templateUrl: "./view-testslips.component.html",
    styleUrls: ["./view-testslips.component.scss"],
    standalone: false
})
export class ViewTestslipsComponent implements OnInit {
  @ViewChild('approveDialog', { static: true }) approveDialog: TemplateRef<any>;
  @ViewChild('forwardToTechnician', { static: true }) forwardToTechnician: TemplateRef<any>;
  @ViewChild('retestDialog', { static: true }) retestDialog: TemplateRef<any>;
  
  public albums: Array<IAlbum>;
  public wireCountAlbum: Array<IAlbum>;
  public permutationChartAlbum: Array<IAlbum>;
  private lightBoxSubscription: Subscription;
  panelOpenState = true;
  navigationnId: any;
  testSlipDetails: any;
  showButtons = 1;
  testPlanListItems: any = [];
  viewUserName: {};
  viewPlanId: {};
  handOverId: any;
  updateByName: any;
  handOverName: any;
  smthFiles: any = [];
  depoAccessArray: any = [];
  userRolesArray: any = [];
  planListItems: any = [];
  testPlanGetId: any;
  smthAuditTrails: any;
  smthComments: any;
  sortByAsc: boolean = true;
  loggedInUser: any;
  userDetails: any;
  defaultSort = true;
  comments = "";
  commentsDataValue = "";
  commentsData: any;
  reviewAccess: any;
  userHasAccess: any;
  enableAddComments = false;
  enableComments = true;
  userValue: boolean = false;
  putValue: boolean = false;
  commentValueData: any = [];
  commentValueDataValue = "";
  commentsChanged: boolean;
  editcomments: boolean = true;
  chkInReview = false;
  enableChangeREviewStatus = false;
  files: any[] = [];
  handSlipId: any;
  handValue: boolean = false;
  dataValue: any;
  showLoader = false;
  digitalWireCount;
  notifySubmitter: boolean = false;
  testPlanPerPage: number = 10;
  brkCountPC: number = 22;
  brkCountWC: number = 25;
  sameUserLogged: boolean = true;
  userConfig: UntypedFormGroup;
  filteredUsers: Observable<AdUserProfile[]>;
  isvalidData: boolean;
  userExists: boolean;
  isLoading: boolean;
  isSFI: boolean;
  subscription: Subscription;
  approvalLevel: any = [];
  associatedTestslip: number = null;
  associatedMessage: string;
  approverEmailLabel: string = "SFI approver email address";
  approverEmail: boolean = false;
  isThirdLevel: boolean = true;
  isPaperTestslip: boolean = false;
  isReadOnly: boolean = false;
  associatedSlips: Array<any> = [];
  handoverForm: FormGroup;
  approvalReason: string;
  approveTestslipPayload: { testSlipId: any; status: any; userId: any; };
  formBuilder: any;
  selectedUser: AdUserProfile;
  userName: any;
  handoverDone: boolean = false;
  sameTechnician: boolean = true;
  mail: any;

  constructor(
    private userProfileService: UserProfileService,
    private ds: DataService,
    private pdf: PrintPDFService,
    private appInsightsService: AppInsightsService,
    private lightbox: Lightbox,
    private lightboxEvent: LightboxEvent,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((res) => {
      if (res && res.testSlipId) {
        const decryptedId = CryptoJS.AES.decrypt(res.testSlipId, environment.ENCRYPTKEY_DATA);
        this.navigationnId = decryptedId.toString(CryptoJS.enc.Utf8);

        if (!this.navigationnId) {
          this.navigationnId = this.ds.decrypt(environment.ENCRYPTKEY_DATA, res.testSlipId);
        }

        this.loadTestSlipDetails(this.navigationnId);
      } else {
        this.router.navigate(["dashboard"]);
      }
    });

    this.handoverForm = new UntypedFormGroup({
      handoverTo: new UntypedFormControl("", Validators.required),
      email: new UntypedFormControl({value:'',disabled:true},Validators.required,)
    });
  }

  ngAfterViewInit() {
    this.isLoading = false;
    this.subscription = this.handoverForm
        .get('handoverTo')
        .valueChanges.subscribe((value) => {
          if (value) {
            if( value.length >= 3 ){
              this.getUsers(value);
            }else{
              this.filteredUsers = of([]);
            }
          }
        }
      );
  }

  loadTestSlipDetails(testSlipId) {
    this.showLoader = true;
    this.ds
      .getService(
        environment.BASEURL + environment.VIEWTESTSLIP + "/" + testSlipId
      )
      .subscribe(
        (res) => {
          this.isReadOnly = this.userProfileService.getIsReadOnly();
          this.testSlipDetails = res;
          this.isPaperTestslip = this.testSlipDetails.smthTestSlipDetailed.testSlipId.includes('P');
          this.smthFiles = this.testSlipDetails.smthFiles;
          this.smthAuditTrails = this.testSlipDetails.smthAuditTrails.reverse();
          this.commentsData = this.testSlipDetails.smthComments;
          this.commentshowData(this.commentsData);
          this.showAssociatedTestslipMessage();
          this.loadRelevantPhotos();
          this.hideApproveButtons();
          this.hideAddCommentsButton();
          this.sameUserLogged =
            this.userProfileService.currentUserObject.id ===
              this.smthAuditTrails[0]?.modifiedBy &&
             (this.smthAuditTrails[0]?.statusName === "SUBMITTED" || this.smthAuditTrails[0]?.statusName === "HANDOVER PENDING")
              ? true
              : false;

          this.isSFI = this.testSlipDetails?.smthTestSlipDetailed.isSFI;
          if (
            this.userRolesArray.includes(7) ||
            this.userRolesArray.includes(8)
          ) {
            this.sameUserLogged =
              this.userProfileService.currentUserObject.id ==
                this.testSlipDetails.smthApproverID
                ? false
                : true;
          }
          if (
            !this.testSlipDetails.smthTestSlipDetailed.faultNo &&
            !this.testSlipDetails.smthTestSlipDetailed.workorderNo
          ) {
            this.testSlipDetails.smthTestSlipDetailed.faultNo = "N/A";
            this.testSlipDetails.smthTestSlipDetailed.workorderNo = "N/A";
          }
          if (this.testSlipDetails.smthTestSlipWireCountDTO) {
            this.loadDigitalWireCountImages();
          }
          if (this.testSlipDetails.smthTestSlipPermutationDTO) {
            this.loadPermutationChartImages();
          }

          if (this.isSFI) {
            this.showLevelApproverButton();
          }

          if (res.smthTestSlipDetailed.testPlanId !== null && !this.isPaperTestslip) {
            this.ds
              .getService(
                environment.BASEURL +
                environment.GETTESTPLANITEMS.replace(
                  "{testPlanId}",
                  res.smthTestSlipDetailed.testPlanId
                )
              )
              .subscribe(
                (items) => {
                  this.testPlanListItems = items;
                  this.updateTestPlanItems(res);
                  this.showLoader = false;
                },
                (err) => {
                  this.showLoader = false;
                }
              );
          } else this.showLoader = false;
        },
        (err) => {
          this.showLoader = false;
        }
      );
  }

  getNameMail(item){
    return `Name:${item.statusName}`
  }

  showAssociatedTestslipMessage() {
    if (this.testSlipDetails.smthAssociatedSlips.length > 0) {
      const associatedSlip = [];
      this.testSlipDetails.smthAssociatedSlips.forEach(slip =>{
        if(slip.associationFlag == 1) {
          associatedSlip.push({
            associatedMessage:'There is a handover test slip associated with this test slip.',
            associatedTestslip: slip.associationFrom > 0 ? slip.associationFrom : slip.associationTo
          })
        }

        if(slip.associationFlag == 2) {
          associatedSlip.push({
            associatedMessage:'There is a retest slip associated with this test slip.',
            associatedTestslip: slip.associationFrom > 0 ? slip.associationFrom : slip.associationTo
          })
        }
      })

      this.associatedSlips = associatedSlip;
    }else {
      if(this.testSlipDetails.smthHandover !== null && this.testSlipDetails.smthAuditTrails[0].status !== 8 
        && this.testSlipDetails.smthAuditTrails[0].sendToMail !== null){
        this.associatedSlips = [{
          associatedMessage:'There is a handover test slip associated with this test slip.',
          associatedTestslip:this.testSlipDetails.smthHandover?.associatedSlip
        }]
      }
      
    }
  }

  getUsers(value: string) {
    const searchResults = [];
    const searchValue = value + '~'
                              + this.testSlipDetails.smthTestSlipDetailed.id
                              + '~'
                              + this.userProfileService.currentUserObject.id;
    let url ;
    url = this.testSlipDetails.smthAuditTrails[0].status === 8 ?  environment.BASEURL + environment.GET_SYSUSER_BY_TEXT.replace(
      '{keyWord}',
      value
    ) :  environment.BASEURL + environment.GET_SYSUSER_BY_TEXT_USERID.replace(
      '{keyWord}',
      searchValue
    );

    this.ds.getService(url)
      .pipe(untilDestroyed(this),
        tap((a) => this.isLoading = false))
      .subscribe(data => {
        let decriptdata = this.ds.decrypt(
          environment.ENCRYPTKEY_DATA,
          data?.users
        );
        this.isLoading = false;
        this.userDetails = JSON.parse(decriptdata);
        this.userDetails.forEach((item) => {
          searchResults.push(item);
        });
        this.isvalidData = searchResults.length > 0 ? true : false;
        this.filteredUsers = of(
          searchResults.length > 0
            ? searchResults.filter((e) => {
              return (e.displayName != null && e.mail != null && e.userPrincipalName != null);
            })
            : ['no data found']
        );
      });
  }

  public displayProperty(value) {
    if (value) {
      return value.mail;
    }
  }

  createForm() {
    this.userConfig = new UntypedFormGroup({
      name: new UntypedFormControl("", Validators.required),
    });

    this.subscription = this.userConfig
      .get('name')
      .valueChanges.subscribe((value) => {
        if (value) {
          value.length >= 3 ? this.getUsers(value) : (this.filteredUsers = of([]));
        }
      }
      );
  }

  showLevelApproverButton() {
    if (this.testSlipDetails.smthTestSlipDetailed.status === 1 ||
      this.testSlipDetails.smthTestSlipDetailed.status === 3
    )

    {
      this.approverEmail = true;
      this.createForm();
      if (this.testSlipDetails.smthLevelApprover.length === 0) {
        this.approvalLevel = ApproverLevel.filter(ele => ele.level === 1);
      } else {
        this.showButtons = 1;

        const smthApprover = this.testSlipDetails.smthLevelApprover.find(ele => {
          return ele.approverId === this.userProfileService.currentUserObject.id;
        })

        const nextLevelApprover = this.testSlipDetails.smthLevelApprover.find(ele => {
          return smthApprover
            && (ele.level > smthApprover.level)
            && (ele.approverId != smthApprover.approverId);
        })

        if (smthApprover && !nextLevelApprover) {
          this.approvalLevel.length = 0;
          if (smthApprover.level === 1 && !smthApprover.directL3Flag) {
            this.approvalLevel.push(
              ApproverLevel.find(ele => ele.level === 2)
            )
          } else {
            this.approverEmail = false;
            this.isThirdLevel = false;
            this.approvalLevel.push(
              ApproverLevel.find(ele => ele.level === 3)
            )
          }
          this.showButtons = 0;
        }
      }
    }
  }

  commaSepEmail(fmails) {
    const emails = fmails.split(";").filter((x) => x);
    let reg = /^([A-Za-z0-9_\&\-\.])+\@networkrail.co.uk$/;
    const forbidden = emails.every((email) => reg.test(email));
    return forbidden;
  }

  sendToNextLevelApproval(approvalLevel, id) {
    let approver = this.userConfig.get('name').value;
    let email = typeof approver === 'object'
      ? approver.mail
      : approver;

    if (!email || !this.commaSepEmail(email)) {
      this.alertService.showAlertDialog(
        "Please enter valid email.",
        AlertType.alert
      );
      return;
    }

    let secondApprover = this.testSlipDetails.smthLevelApprover.find(ele => ele.level === 1);

    if (
      (secondApprover?.approverId === approver.userId)
      || (id === 'L3'
        && this.userProfileService.currentUserObject.id === approver.userId)
    ) {
      this.alertService.showAlertDialog(
        "Please select a different approver name since you have already approved the Test slip.",
        AlertType.alert
      );
      return;
    }

    const approverDateTime = new Date(
      new Date().toString().split("GMT")[0] + " UTC"
    ).toISOString();
    const payload = {
      id: 0,
      testSlipId: this.testSlipDetails.smthTestSlipDetailed.id,
      approverId: approver.userId,
      level: approvalLevel.level,
      approverDate: approverDateTime,
      directL3Flag: Number(
        this.testSlipDetails.smthLevelApprover.length === 0
        && id === 'L3'
      ),
      modifiedId: this.userProfileService.currentUserObject.id
    };

    let url = environment.BASEURL + environment.Level_Approval;
    if (this.chkInReview) {
      url += "?setInReview=true";
    }

    this.ds.createService(url, payload).subscribe((response) => {
      if(response) {
        this.showButtons = 1;
        this.loadTestSlipDetails(payload.testSlipId);
      }
    });
  }

  commentshowData(data) {
    if (this.putValue) {
      this.commentValueData = [];
    }
    if (data.length > 0) {
      data.map((dataCommentData) => {
        if (
          dataCommentData.commentedBy ===
          this.userProfileService.currentUserObject.id
        ) {
          dataCommentData.userValue = true;
          dataCommentData.valueAdded = false;
        } else {
          dataCommentData.userValue = false;
          dataCommentData.valueAdded = false;
        }
        this.commentValueData.push(dataCommentData);
      });
    }
  }
  editUpdateValue(e, event) {
    const commentDateTime = new Date(
      new Date().toString().split("GMT")[0] + " UTC"
    ).toISOString();

    const formData = new FormData();

    const payload =  {
      SmthComments: {
        id: e.id,
        testSlipId: this.testSlipDetails.smthTestSlipDetailed.id,
        comments: this.commentValueDataValue,
        commentedBy: this.userProfileService.currentUserObject.id,
        commentedDate: commentDateTime,
      }
    };

    const smthComments= btoa(JSON.stringify(payload));
    formData.append("SmthComments",smthComments);

    let dialogData = new ConfirmDialogModel(
      "Alert",
      "Comments Updated Successfully!!",
      "simpleconfirm"
    );
    this.ds
      .createService(environment.BASEURL + environment.ADD_COMMENTS, formData)
      .subscribe((res) => {
        this.getComments();
        this.alertDialog(dialogData);
        this.enableComments = true;
        this.editcomments = true;
        this.commentsChanged = false;
      });
  }

  editUpdate(e, event) {
    this.commentValueDataValue = event.target.value;
  }

  commentChanged(event) {
    this.commentsChanged = true;
  }

  updateTestPlanItems(testSlipResult) {
    if (this.testPlanListItems && this.testPlanListItems.length > 0) {
      this.testPlanListItems.forEach((testPlan) => {
        testPlan.smthTestPlans.forEach((item) => {
          const found = testSlipResult.testSlipDetailsSubSections?.find(
            (x) => x.testPlanDetailsId === item.id
          );
          if (found) {
            item.answer = this.setAnswer(found.result);
            item.comments = found.comments;
            item.subSection = found.subSection;
          }
          if (!found && testSlipResult.smthTestSlipDetailed.isSFI === 1) {
            item.answer = '4';
          }
        });
      });
    }
  }

  setAnswer(result) {
    if (result === "Yes") {
      return 1;
    }
    if (result === "No") {
      return 2;
    }
    if (result === "NA") {
      return 3;
    }
  }

  showButton(q, buttonType) {
    const qTypes = q.questionType.split("/").map((item) => item.trim());
    if (buttonType === 1) {
      return qTypes.indexOf("Yes") > -1 ? true : false;
    }
    if (buttonType === 2) {
      return qTypes.indexOf("No") > -1 ? true : false;
    }
    if (buttonType === 3) {
      return qTypes.indexOf("NA") > -1 ? true : false;
    }
  }

  hideApproveButtons() {
    let userObject = this.userProfileService.getLoggedinUserDetails();
    this.userRolesArray = this.userProfileService.getLoggedinUserRoles();
    let statusAccess = false;

    //Checking if user is having depo access
    for (let i = 0; i < userObject.smthOrgStructure.length; i++) {
      this.depoAccessArray.push(userObject.smthOrgStructure[i].id);
    }
    this.userHasAccess = this.depoAccessArray.includes(
      this.testSlipDetails.smthTestSlipDetailed.depotId
    );
    if (this.userRolesArray.includes(7) || this.userRolesArray.includes(8)) {
      this.userHasAccess =
        this.userProfileService.currentUserObject.id ==
          this.testSlipDetails.smthApproverID
          ? true
          : false;
    }
    //Checking if user role is 'Review Test Slip'
    this.reviewAccess =
      this.userRolesArray.includes(2) || this.userRolesArray.includes(7);

    //Checking if test slip status is 'Submitted' or 'In Review' or 'pending handovers'
    if (
      this.testSlipDetails.smthTestSlipDetailed.status === 1 ||
      this.testSlipDetails.smthTestSlipDetailed.status === 3 ||
      this.testSlipDetails.smthTestSlipDetailed.status === 8
    ) {
      statusAccess = true;
    }

    //Checking if userObject is not null, if user has access to depo, if ticket is not approved and user role is
    //'Review Test Slip'
    if (
      userObject &&
      userObject.userRoles &&
      this.userHasAccess &&
      this.reviewAccess &&
      statusAccess
    ) {
      this.showButtons = 0;
    }
  }

  hideAddCommentsButton() {
    let submittedUser = false;
    let handOverUser = false;

    // checking if logged in user and submitted are same
    if (
      this.testSlipDetails.smthAuditTrails[0] &&
      this.userProfileService.currentUserObject.id ==
      this.testSlipDetails.smthAuditTrails[0].modifiedBy
    ) {
      submittedUser = true;
    }
    // Checking if handedover user and logged in user are same
    if (this.testSlipDetails.smthHandover) {
      if (
        this.userProfileService.currentUserObject.id ==
        this.testSlipDetails.smthHandover.handedOverTo
      ) {
        handOverUser = true;
      }
    }

    // if user role is only Admin, add comments is enabled
    if (this.userRolesArray.length > 0 && this.userRolesArray.includes(4)) {
      this.enableAddComments = true;
    }

    if (
      (submittedUser || handOverUser || this.reviewAccess) &&
      this.userHasAccess
    ) {
      this.enableAddComments = true;
    }

    if (
      (this.userRolesArray.length > 0 && this.userRolesArray.includes(4)) ||
      this.userRolesArray.includes(2) ||
      this.userRolesArray.includes(7) 
    ) {
      this.enableChangeREviewStatus = true;
    }
  }

  loadRelevantPhotos() {
    this.albums = [];
    for (let i = 0; i < this.smthFiles.length; i++) {
      const src = this.smthFiles[i].filePath;
      const caption = "";
      const thumb = this.smthFiles[i].filePath;
      const album = {
        src,
        caption,
        thumb,
        downloadUrl: ''
      };
      this.albums.push(album);
    }
  }

  // getUserNameValue() {
  //   if (this.viewUserName) {
  //     this.ds
  //       .getService(
  //         environment.BASEURL +
  //         environment.VIEWUSERNAME +
  //         "/" +
  //         this.viewUserName
  //       )
  //       .subscribe((data) => {
  //         this.updateByName = data[0];
  //       });
  //   }
  // }
  getViewPlanId() {
    if (this.viewPlanId) {
      this.ds
        .getService(
          environment.BASEURL + environment.VIEWTESTPLAN + "/" + this.viewPlanId
        )
        .subscribe((data) => {
          this.testPlanGetId = data;
        });
    }
  }
  // getHandOverId() {
  //   if (this.handOverId) {
  //     this.ds
  //       .getService(
  //         environment.BASEURL + environment.VIEWUSERNAME + "/" + this.handOverId
  //       )
  //       .subscribe((value) => {
  //         this.handOverName = value[0];
  //       });
  //   }
  // }

  onRetestSelctionChange(event){
    this.sameTechnician = event.value === '1' ? true : false;
  }

  onRetest(){
  if(this.sameTechnician){
    const SubmitedId = this.testSlipDetails.smthAuditTrails.filter(val => {
      return val.statusName === 'SUBMITTED';
    }).map(val => val.modifiedBy )
    const payload = {
      testSlipId: this.testSlipDetails.smthTestSlipDetailed.id,
      status: 4,
      userId: this.userProfileService.currentUserObject.id,
      sendToUserId: SubmitedId[0]
    };
    this.submitRetest(payload);
  }else{
      this.getUserDetailas('Re-test')
    }
  }

  submitRetest(payload){
     // sent to retest
    this.confirmDialog("Do you want to update the status to Retest?")
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult) {
          this.ds
            .createService(
              environment.BASEURL + environment.SETTESTSLIPSTATUS,
              payload
            )
            .subscribe((res) => {
              this.testSlipDetails.smthTestSlipDetailed.status = 4;
              this.showButtons = 1;
              this.loadTestSlipDetails(payload.testSlipId);
            });
        }
      });
  }

  approveTestSlip(approver = null) {
    const testslipStatus = approver === null ? 2 : approver.status;
    this.approveTestslipPayload = {
      testSlipId: this.testSlipDetails.smthTestSlipDetailed.id,
      status: testslipStatus,
      userId: this.userProfileService.currentUserObject.id,
    };
    if(this.testSlipDetails.smthAuditTrails[0].statusName === "HANDOVER PENDING"){
      this.dialog.open(this.approveDialog,{width: '600px'});
    } else{
      this.confirmDialog("Do you want to update the status to Approved?")
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult) {
          this.updateTestSlipStatus(this.approveTestslipPayload)
        }
      });
    }
  }

  onConfirm(){
   const payload = {approvalReason: this.approvalReason, ...this.approveTestslipPayload}
    this.updateTestSlipStatus(payload)
  }
 
  updateTestSlipStatus(payload){
   this.ds
    .createService(
      environment.BASEURL + environment.SETTESTSLIPSTATUS,
      payload
    )
    .subscribe((res) => {
      this.appInsightsService.logPageView('Approve - ' + this.testSlipDetails.smthTestSlipDetailed.depot);
      this.testSlipDetails.smthTestSlipDetailed.status = 2;
      this.showButtons = 1;
      this.loadTestSlipDetails(payload.testSlipId);
    });
  }

  forwardHandover(){
    this.dialog.open(this.forwardToTechnician,{width: '600px'});
  }

  resetForm(){
    this.handoverForm.reset();
    this.selectedUser = null;
   }

  onHandover(){
    this.getUserDetailas('handover')
  }

  submitHandover(handoverTo){
    this.ds
    .createService(
      environment.BASEURL +
      environment.UPDATE_HANDOVER.replace(
        "{testSlipId}",
        this.testSlipDetails.smthTestSlipDetailed.id
      ).replace("{handOverFrom}",
      this.userProfileService.currentUserObject.id
      ).replace(
        "{handedOverTo}",
        handoverTo
      ), {}).subscribe(res => {
        this.appInsightsService.logPageView('Handoverd - ' + this.testSlipDetails.smthTestSlipDetailed.depot);
       // this.testSlipDetails.smthTestSlipDetailed.status = 1;
       // this.showButtons = 1;
        this.handoverDone = true;
        this.loadTestSlipDetails( this.testSlipDetails.smthTestSlipDetailed.id);
      })
  }

  getUserDetailas(value){
    const userEmailAddress = this.handoverForm.value.handoverTo.mail.toLowerCase();
    console.log('userEmailAddress',userEmailAddress)
    const text = value === 'handover' ? 'Handover' : 'Re-test'
    this.ds
    .getService<any>(
      environment.BASEURL +
        environment.GET_USER_BY_ADID.replace('{email}', userEmailAddress)
    ).pipe(untilDestroyed(this)).subscribe(
      (res) =>{
        console.log(res)
        if (!res) {
          const dialogData = new ConfirmDialogModel(
            text,
            `${text} user not found.`,
            "simpleconfirm"
          );
          this.alertDialog(dialogData);
        } else if (res.id === this.userProfileService.currentUserObject.id) {
          const dialogData = new ConfirmDialogModel(
            text,
            `${text} can not be assigned to user performing test.`,
            "simpleconfirm"
          );
          this.alertDialog(dialogData);
        } else {
          const id = res.id
          if(text === 'Handover'){
            this.submitHandover(id)
          }else{
            const payload = {
              testSlipId: this.testSlipDetails.smthTestSlipDetailed.id,
              status: 4,
              userId: this.userProfileService.currentUserObject.id,
              sendToUserId: id
            };
            this.submitRetest(payload)
          }
        }
      }
    )
  }

  public displayName(value) {
    if (value) {
     // console.log(value);
      return value.displayName;
    }
  }

  public displayEmailProperty(value){
    if (value) {
      console.log(value);
      return value.mail;
    }
  }

  getuserData(event) {
    this.selectedUser = event.option.value;
    this.userName = event.option.value.displayName;
  }

  getComments() {
    this.commentsData = [];
    this.commentValueData = [];
    this.ds
      .getService(
        environment.BASEURL +
        environment.GET_COMMENTS +
        "/" +
        this.testSlipDetails.smthTestSlipDetailed.id
      )
      .subscribe((data) => {
        this.commentsData = data;
        this.putValue = true;
        this.commentshowData(this.commentsData);
      });
  }

  addComment() {
    this.showLoader = true;
    const commentDateTime = new Date(
      new Date().toString().split("GMT")[0] + " UTC"
    ).toISOString();

    const formData = new FormData();
    this.files.forEach(file => {
      formData.append('formFiles', file);
    });

    const payload =  {
      SmthComments: {
        id: 0,
        testSlipId: this.testSlipDetails.smthTestSlipDetailed.id,
        comments: this.comments,
        commentedBy: this.userProfileService.currentUserObject.id,
        commentedDate: commentDateTime,
        notifySubmitter: this.notifySubmitter ? true : false
      },
      setInReview: this.chkInReview
    };

    const smthComments= btoa(JSON.stringify(payload));
    formData.append("SmthComments",smthComments);

    let message;

    if(this.files.length > 0 && this.comments) {
      message = "Comments and document added successfully!!";
    } else if (this.files.length === 0) {
      message = "Comments added successfully!!";
    } else {
      message = "Documents added successfully!!";
    }

    let dialogData = new ConfirmDialogModel(
      "Alert",
      message,
      "simpleconfirm"
    );

    let url = environment.BASEURL + environment.ADD_COMMENTS;

    this.ds.createService(url, formData).subscribe((res) => {
      this.getComments();
      this.alertDialog(dialogData);
      this.comments = "";
      this.commentsData = [];
      this.commentValueData = [];
      this.files.length = 0;
      this.showLoader = false;
      if (this.chkInReview) {
        this.loadTestSlipDetails(this.navigationnId);
        // this.testSlipDetails.smthTestSlipDetailed.status = 3;
      }
      this.notifySubmitter = false;
    }, (error) => {
      this.showLoader = false;
    });
  }

  open(index: number, imagesAlbum,): void {
    this.lightBoxSubscription = this.lightboxEvent.lightboxEvent$.subscribe(
      (event: IEvent) => this._onReceivedEvent(event)
    );
    if (imagesAlbum === "wireCountAlbum") {
      this.lightbox.open(this.wireCountAlbum, index, {
        wrapAround: true,
        showImageNumberLabel: false,
        showZoom: true,
        showRotate: false,
      });
    }
   else  if (imagesAlbum === "permutationChartAlbum") {
      this.lightbox.open(this.permutationChartAlbum, index, {
        wrapAround: true,
        showImageNumberLabel: false,
        showZoom: true,
        showRotate: false,
      });
    } else if(imagesAlbum === "albums") {
      this.lightbox.open(this.albums, index, {
        wrapAround: true,
        showImageNumberLabel: false,
        showZoom: true,
        showRotate: false,
      });
    }
  }

  private _onReceivedEvent(event: IEvent): void {
    if (event.id === LIGHTBOX_EVENT.CLOSE) {
      this.lightBoxSubscription.unsubscribe();
    }
  }

  sendForRetest() {
    this.dialog.open(this.retestDialog,{width: '600px'});
    this.sameTechnician = true;
  }

  confirmDialog(message) {
    const dialogData = new ConfirmDialogModel(
      "SMTH Portal",
      message,
      "confirm"
    );
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      height: "250px",
      width: "600px",
      data: dialogData,
    });

    return dialogRef;
  }

  alertDialog(dialogData) {
    let result: string = "";
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      height: "250px",
      width: "600px",
      data: dialogData,
    });
  }

  backButtonNavigate() {
    if (!this.handValue) {
      this.router.navigate(["/dashboard"]);
    } else {
      this.ds.handOverSlipID.subscribe((res) => {
        if (res) {
          this.dataValue = res;
        }
      });

      const navigationExtras: NavigationExtras = {
        queryParams: {
          testSlipId: this.dataValue,
        },
      };
      this.handValue = false;
      this.router.navigate(["/view-testslips"], navigationExtras);
    }
  }

  sortData(ev) {
    this.defaultSort = !this.defaultSort;
    this.smthAuditTrails.sort(this.dynamicSort(ev));
  }

  dynamicSort(prop) {
    let sortOrder = 1;
    if (!this.defaultSort) {
      sortOrder = -1;
    }

    return (a, b) => {
      let result = a[prop] < b[prop] ? -1 : a[prop] > b[prop] ? 1 : 0;
      return result * sortOrder;
    };
  }

  editCommentValue(i, comments) {
    comments.userValue = false;
    comments.valueAdded = true;
    this.editcomments = false;
  }

  cancelComment(comments, event) {
    this.getComments();
    comments.userValue = true;
    comments.valueAdded = false;
    this.commentsChanged = false;
  }

  deleteCommentValue(e) {
    const id = e.id;
    let dialogData = new ConfirmDialogModel(
      "Alert",
      "Comments Deleted Successfully!!",
      "simpleconfirm"
    );
    this.confirmDialog("Do you want to delete the comment?")
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult) {
          this.showLoader = true;
          this.ds
            .deleteComments(
              environment.BASEURL + environment.DELETE_COMMENTS + "/" + id
            )
            .subscribe((res) => {
              this.showLoader = false;
              this.getComments();
              this.alertDialog(dialogData);
              this.comments = "";
              this.commentsData = [];
              this.commentValueData = [];
            }, (error) => {
              this.showLoader = false;
            });
        }
      });
  }

  async exportToPDF() {
    this.showLoader = true;
    let ans = await this.pdf.exportToPDF(
      this.albums,
      this.smthAuditTrails,
      this.commentValueData,
      this.testPlanListItems,
      this.testSlipDetails
    );
    // window.location.reload();
    this.showLoader = false;
  }

  filteredWireCountDTO(x): Wirecount[] {
    return this.testSlipDetails.smthTestSlipWireCountDTO.filter(
      (y) => y.testPlanId === x
    );
  }

  viewAssociatedNavigate(associatedSlip) {
    const testSlipId = associatedSlip.associatedTestslip;
    const encryptedSlipId = encodeURIComponent(
      CryptoJS.AES.encrypt(JSON.stringify(testSlipId),
        environment.ENCRYPTKEY_DATA).toString()
    );
    this.handValue = true;
    if (testSlipId !== 0) {
      let newPath = `${window.location.origin}#/view-testslips?testSlipId=${encryptedSlipId}`;
      window.open(newPath, "_blank");
    } else {
      let dialogData = new ConfirmDialogModel(
        "Alert",
        "Handed over Test Slip is not Submitted!!",
        "simpleconfirm"
      );
      this.alertDialog(dialogData);
    }
  }

  loadDigitalWireCountImages() {
    this.wireCountAlbum = [];
    for (
      let i = 0;
      i < this.testSlipDetails.smthTestSlipWireCountDTO.length;
      i++
    ) {
      if (this.testSlipDetails.smthTestSlipWireCountDTO[i].fileData !== null) {
       // this.wireCountAlbum = [];
        const src = this.testSlipDetails.smthTestSlipWireCountDTO[i].fileData;
        const caption = '';
        const thumb = this.testSlipDetails.smthTestSlipWireCountDTO[i].fileData;
        const album = {
          src,
          caption,
          thumb,
          downloadUrl: ''
        };
        this.wireCountAlbum.push(album);
      }
    }
  }

  loadPermutationChartImages() {
    for (
      let i = 0;
      i < this.testSlipDetails.smthTestSlipPermutationDTO.length;
      i++
    ) {
      if (
        this.testSlipDetails.smthTestSlipPermutationDTO[i].fileData !== null
      ) {
        this.permutationChartAlbum = [];
        const src = this.testSlipDetails.smthTestSlipPermutationDTO[i].fileData;
        const caption = "";
        const thumb =
          this.testSlipDetails.smthTestSlipPermutationDTO[i].fileData;
        const album = {
          src,
          caption,
          thumb,
          downloadUrl: ''
        };
        this.permutationChartAlbum.push(album);
      }
    }
  }

  wireCountText(smthTestSlipWireCountDTO, smthTestPlanId) {
    return smthTestSlipWireCountDTO
      ? smthTestSlipWireCountDTO.filter((x) => x.testPlanId === smthTestPlanId)
        .length > 0
        ? true
        : false
      : false;
  }

  downloadFile(file) {
    const linkSource = file.filePath;
    const downloadLink = document.createElement('a');

    downloadLink.href = linkSource;
    downloadLink.download = file.fileName;
    downloadLink.click();
  }

  uploadFile(event) {
    for (let index = 0; index < event.files.length; index++) {
      const element = event.files[index];
      const fileSize = Math.round((element.size / 1024));
      const allowedExtensions =
                    /(\.pdf|\.docx|\.jpg|\.jpeg|\.png|\.gif)$/i;

      if (!allowedExtensions.exec(event.value)) {
        this.alertService.showAlertDialog(
          'Invalid file type',
          AlertType.alert
        );
        event.value = '';
        return;
      }
      if(fileSize > environment.FILE_SIZE) {
        this.alertService.showAlertDialog(
          `File size exceeds maximum limit of ${Math.round(environment.FILE_SIZE/1024)}MB.`,
          AlertType.alert
        );
        return;
      }
      this.files.push(element);
      event.value = '';
    }
  }

  deleteAttachment(index) {
    let dialogData = new ConfirmDialogModel(
      "Alert",
      "Domments deleted successfully!!",
      "simpleconfirm"
    );
    this.confirmDialog("Do you want to delete the document?")
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult) {
          this.files.splice(index, 1)
        }
      });
  }

  handleApproveinHandover(){
    const isUnknown = this.testSlipDetails.smthAuditTrails.some(val => val.status === 8)
    if(isUnknown){
     return !this.testSlipDetails.smthAuditTrails.some(val => val.status === 9)
     }else{
      return this.testSlipDetails.smthHandover === null;
    }                                                    
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  isUnKnown(){
    return this.testSlipDetails.smthAuditTrails.some(val => val.status === 8) && !this.testSlipDetails.smthAuditTrails.some(val => val.status === 9)
  }
}
